export const PLAYER_GRADIENTS = [
	'bg-gradient-to-br from-pink-400 to-orange-600',
	'bg-gradient-to-br from-red-500 to-pink-600',
	'bg-gradient-to-br from-green-500 to-teal-600',
	'bg-gradient-to-br from-yellow-500 to-orange-600',
	'bg-gradient-to-br from-purple-500 to-indigo-600'
];

export const VALID_RANKS = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

export const AVATARS = [
	'🐶', '🐱', '🐯', '🐰', '🐮', '🐹', '🐨',
	'🐼', '🐙', '🐵', '🐧', '🦊', '🐷',
	'🐸', '🦁', '🦘', '‍🦦️', '‍🦭️', '🦉', '🐳'
];

// Settings for the card deal animation
export const CARD_DEAL_INTERVAL = 70; // ms between each card deal
export const CARD_FLIGHT_TIME = 500; // ms for card to fly to player
